import { get } from "@src/appV2/api/api";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import {
  type QueryClient,
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from "@tanstack/react-query";
import { z } from "zod";

import { CHECKR_APPLICATION_STATUS_URL } from "./constants";

const checkrApplicationStatusSchema = z.object({
  invitationStatus: z.string().optional(),
  reportStatus: z.string().optional(),
  invitationUrl: z.string().optional(),
  autoShiftUnassignmentAt: z.string().nullish(),
});

export const checkrApplicationStatusResponseSchema = z.object({
  data: checkrApplicationStatusSchema,
});

export type CheckrApplicationStatusResponse = z.infer<typeof checkrApplicationStatusResponseSchema>;

export async function invalidateCheckrApplicationStatus(queryClient: QueryClient) {
  await queryClient.invalidateQueries({ queryKey: [CHECKR_APPLICATION_STATUS_URL] });
}

export function useGetCheckrApplicationStatus(
  options: UseQueryOptions<CheckrApplicationStatusResponse> = {}
): UseQueryResult<CheckrApplicationStatusResponse> {
  return useQuery({
    queryKey: [CHECKR_APPLICATION_STATUS_URL],
    queryFn: async () => {
      const response = await get({
        url: CHECKR_APPLICATION_STATUS_URL,
        responseSchema: checkrApplicationStatusResponseSchema,
      });

      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_CHECKR_APPLICATION_STATUS_FAILURE,
    },
    ...options,
  });
}
